import type { BaseEntity } from 'c-sdk';
import type { SlicePaginationData } from '../../Types';
import { NetworkRequestState } from '../../Types';

const slicePaginationData = <Entity extends BaseEntity>(): SlicePaginationData<Entity> => ({
    data: [],
    filters: {},
    includes: [],
    searchables: {},
    loadingState: { state: NetworkRequestState.Idle },
});

export default slicePaginationData;
